let routes = [
  {
    path: "/cart",
    name: "Cart",
    meta: {
      requiresAuth: true,
      slug: "cart"
    },
    component: () => import("@/views/checkout/Cart.vue")
  },
  {
    path: "/checkout",
    name: "Checkout",
    meta: {
      requiresAuth: true,
      slug: "checkout"
    },
    component: () => import("@/views/checkout/Checkout.vue")
  },
  {
    path: "/payment",
    name: "Payment",
    meta: {
      requiresAuth: true,
      slug: "payment"
    },
    component: () => import("@/views/checkout/Payment.vue")
  },
  {
    path: "/cart/payment-error/:orderId",
    name: "PaymentError",
    meta: {
      requiresAuth: true,
      slug: "cart/payment-error"
    },
    props: {
      canRepay: true,
      isPaymentError: true
    },
    component: () => import("@/views/checkout/PaymentCompleted.vue")
  },
  {
    path: "/cart/payment-completed/:orderId",
    name: "PaymentCompleted",
    meta: {
      requiresAuth: true,
      slug: ["payment-completed"]
    },
    props: {
      canRepay: false,
      isPaymentError: false
    },
    component: () => import("@/views/checkout/PaymentCompleted.vue")
  }
];

export default routes;
